(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["expert-recommendations"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('expert-slider')) {
    customElements.define('expert-slider', class extends HTMLElement {
      constructor() {
        super();
        this.track = this.querySelector('.expert-slider-track');
        this.container = this.querySelector('.expert-slider-container');
        this.autoplay = this.dataset.autoplay === 'true';
        this.speed = parseInt(this.dataset.speed);
        this.currentIndex = 0;
        this.isTransitioning = false;
        
        // Initial Slides (needed before cloning)
        this.slides = Array.from(this.track.children);
        this.totalOriginal = this.slides.length;
        
        if (this.totalOriginal < 4) return; // Need enough for logic

        this.init();
      }

      init() {
        // Clone slides for infinite effect (3 on each side for safety)
        for(let i=0; i<6; i++) {
          const firstClone = this.slides[i % this.totalOriginal].cloneNode(true);
          const lastClone = this.slides[(this.totalOriginal - 1 - i) % this.totalOriginal].cloneNode(true);
          this.track.appendChild(firstClone);
          this.track.insertBefore(lastClone, this.track.firstChild);
        }

        // Updated slide list
        this.allSlides = Array.from(this.track.children);
        this.currentIndex = 6; // Start at first original slide
        
        // Initial positioning
        this.updatePosition(true);
        this.updateActive();

        if (this.autoplay) this.startAutoplay();
        
        // Resize listener
        window.addEventListener('resize', () => this.updatePosition(true));
      }

      updatePosition(noTransition = false) {
        if (noTransition) this.track.classList.add('no-transition');
        const slideWidth = this.allSlides[0].offsetWidth;
        this.track.style.transform = `translateX(-${this.currentIndex * slideWidth}px)`;
        if (noTransition) {
          this.track.offsetHeight; // Flush styles
          this.track.classList.remove('no-transition');
        }
      }

      next() {
        if (this.isTransitioning) return;
        this.isTransitioning = true;
        this.currentIndex++;
        this.updatePosition();
        this.updateActive();
        
        this.track.addEventListener('transitionend', () => {
          this.isTransitioning = false;
          if (this.currentIndex >= this.totalOriginal + 6) {
            this.currentIndex = 6;
            this.updatePosition(true);
          }
        }, { once: true });
      }

      updateActive() {
        // Remove all active
        this.allSlides.forEach(s => s.classList.remove('is-active'));
        
        // 3rd item from the right in a 6-item view means 4th slot (index 3)
        // Visually: [0][1][2] [3 ACTIVE] [4][5]
        const activeIdx = this.currentIndex + 3;
        if (this.allSlides[activeIdx]) {
          this.allSlides[activeIdx].classList.add('is-active');
        }
      }

      startAutoplay() {
        this.autoplayTimer = setInterval(() => this.next(), this.speed);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-experience"] && !Shopify.designMode) return;
  try {
    
  class HeroSlider extends HTMLElement {
    constructor() {
      super();
      this.container = this.querySelector('.scroll-container');
      this.isDragging = false;
      this.startX = 0;
      this.scrollLeft = 0;

      this.init();
    }

    init() {
      if (!this.container) return;

      this.container.addEventListener('mousedown', (e) => {
        this.isDragging = true;
        this.startX = e.pageX - this.container.offsetLeft;
        this.scrollLeft = this.container.scrollLeft;
        this.container.classList.add('active');
      });

      window.addEventListener('mouseleave', () => {
        this.isDragging = false;
      });

      window.addEventListener('mouseup', () => {
        this.isDragging = false;
      });

      window.addEventListener('mousemove', (e) => {
        if (!this.isDragging) return;
        e.preventDefault();
        const x = e.pageX - this.container.offsetLeft;
        const walk = (x - this.startX) * 1.5;
        this.container.scrollLeft = this.scrollLeft - walk;
      });

      // Touch events
      this.container.addEventListener('touchstart', (e) => {
        this.startX = e.touches[0].pageX - this.container.offsetLeft;
        this.scrollLeft = this.container.scrollLeft;
      });

      this.container.addEventListener('touchmove', (e) => {
        const x = e.touches[0].pageX - this.container.offsetLeft;
        const walk = (x - this.startX) * 1.5;
        this.container.scrollLeft = this.scrollLeft - walk;
      });
    }
  }

  customElements.define('hero-slider', HeroSlider);

  } catch(e) { console.error(e); }
})();
})();
